import { createRoot } from "react-dom/client";
// Self-hosted fonts (bundled by Vite from npm), so pages never make a request to
// a third-party font CDN that would see visitors' IP addresses.
import "@fontsource/source-serif-4/400.css";
import "@fontsource/source-serif-4/700.css";
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/600.css";
import "@fontsource/source-sans-3/700.css";
import "./global.css";
import { App } from "./App.js";

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(<App />);
}
